import { FC } from "react"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"

type InfoItem = {
   iconName: IconProps["name"]
   name: string
}

interface InfoCardProps {
   title: string
   iconName: IconProps["name"]
   items: InfoItem[]
}

export const InfoCard: FC<InfoCardProps> = ({ title, iconName, items }) => (
   <div className="inmate-detail-overview__section">
      <div className="inmate-detail-overview__section-header">
         <span className="inmate-detail-overview__section-title">
            <Icon
               name={iconName}
               size="24"
               color={IconColor.HONOLULU_BLUE}
            />
            <span>{title}</span>
         </span>
      </div>
      <div className="inmate-detail-overview__section-body info-section__body">
         {items.map((item) => (
            <div
               className="inmate-detail-overview__section-unit inmate-detail-overview__section-item"
               key={item.name}
            >
               <Icon
                  name={item.iconName}
                  size="32"
                  color={IconColor.HONOLULU_BLUE}
               />
               <span>{item.name}</span>
            </div>
         ))}
      </div>
   </div>
)
